/* global MEDIA_ROOT */

import React, { PropTypes, PureComponent } from 'react';

import { container } from './styles.module.css';

/**
 * Google Map component
 */

class GoogleMap extends PureComponent {
  componentDidMount() {
    this.initMap();
  }

  componentDidUpdate() {
    this.initMap();
  }

  initMap = () => {
    const {
      googleAPI,
      lat,
      lng,
      zoom,
      scrollwheel,
      streetViewControl,
      mapTypeControl,
    } = this.props;

    const latLng = {
      lat,
      lng,
    };

    const map = new googleAPI.maps.Map(this.container, {
      center: latLng,
      zoom,
      scrollwheel,
      streetViewControl,
      mapTypeControl,
    });

    this.marker = new googleAPI.maps.Marker({
      position: latLng,
      map,
      icon: `${MEDIA_ROOT}/icons/icn_locationmarker_small.png`,
    });

    // Refresh map once it's finished loading:
    googleAPI.maps.event.addListenerOnce(map, 'idle', () => {
      googleAPI.maps.event.trigger(map, 'resize');
    });
  }

  render() {
    return (
      <div className={container} ref={(node) => { this.container = node; }} />
    );
  }
}

export default GoogleMap;

GoogleMap.propTypes = {
  /**
   * Google Maps API object, supplied by async script wrapper component (for client only).
   */
  googleAPI: PropTypes.shape(),
  /**
   * Latitude for map marker/centering the map.
   */
  lat: PropTypes.number.isRequired,
  /**
   * Longitude for map marker/centering the map.
   */
  lng: PropTypes.number.isRequired,
  /**
   * Number for level of zoom on first load. Higher the number, the more zoomed in.
   */
  zoom: PropTypes.number,
  /**
   * When hovering over the map, should user's scrolling control zoom.
   */
  scrollwheel: PropTypes.bool,
  /**
   * On-screen control for showing streetview.
   */
  streetViewControl: PropTypes.bool,
  /**
   * On-screen option for showing either map or satellite view.
   */
  mapTypeControl: PropTypes.bool,
};

GoogleMap.defaultProps = {
  googleAPI: undefined,
  streetViewControl: false,
  mapTypeControl: false,
  scrollwheel: false,
  zoom: 9,
};



// WEBPACK FOOTER //
// ./app/src/components/GoogleMap/index.jsx